import { Dayjs, PluginFunc } from 'dayjs';

import { RelativeTimeInput, RelativeTimeOptions } from '../type';
import { getPluralType } from '../util';

const plugin: PluginFunc<RelativeTimeOptions> = function (options, dayjsClass, dayjs) {
  const proto = dayjsClass.prototype;

  const fromToBase = function (input: RelativeTimeInput, instance: Dayjs, useAbbreviation: boolean): string {
    const localeConfig = instance.$locale();
    const { thresholds, rounding } = options;
    let durationStr = '';

    for (let i = 0; i < thresholds.length; i += 1) {
      const { relativeTimeKey, num, unit } = thresholds[i];
      const thresholdDiff = dayjs(input).diff(instance, unit, true);
      const absThresholdDiff = rounding(Math.abs(thresholdDiff));
      if (absThresholdDiff >= num) {
        const absDiff = rounding(Math.abs(dayjs(input).diff(instance, relativeTimeKey, true)));
        const pluralType: string = getPluralType(absDiff, instance.$locale().name);
        const tense = thresholdDiff > 0 ? 'future' : 'past';
        const templateMap = useAbbreviation ? localeConfig.abbr[relativeTimeKey] : localeConfig[tense][relativeTimeKey];
        const template = templateMap[pluralType] || '';
        durationStr = template.replace('%s', `${absDiff}`);
        break;
      }
    }
    return durationStr;
  };

  proto.to = function (input: RelativeTimeInput, useAbbreviation = false): string {
    return fromToBase(input, this, useAbbreviation);
  };
};

export default plugin;
